import { MAB as MABIcon } from "assets/icons";
import {
  DropdownSetting,
  InformationSetting,
  RememberSettings,
  ToggleSetting,
} from "components/settings";
import { WidgetNames } from "constants/widgets";
import { WidgetType } from "types/Widget";

import { MAB, MABWidgetState, defaultBlockPositions } from "./MAB";

export const MABWidget: WidgetType<MABWidgetState> = {
  name: "MAB",
  component: MAB,
  icon: MABIcon,
  showOnToolbar: true,
  sizing: {
    minWidth: 393,
    minHeight: 262,
    minAspectRatio: 1.5,
    maxAspectRatio: 1.5,
  },
  defaultState: {
    blockPositions: defaultBlockPositions,
    target: 0,
  },
  defaultSize: {
    aspectRatio: 1.5,
    widthPercentage: 50,
  },
  settings: {
    header: {
      editor: InformationSetting,
      info: {
        info: "Colorful blocks representing ones, tens, hundreds, and more for hands-on learning of arithmetic operations.",
      },
    },
    maxColumn: {
      editor: DropdownSetting,
      info: {
        name: "Highest Unit",
        options: ["Thousands", "Hundreds", "Tens", "Ones"],
      },
      defaultValue: "Thousands",
    },
    showNumbers: {
      editor: ToggleSetting,
      info: {
        label: "Show Total Per Column",
      },
      defaultValue: true,
    },
    showResult: {
      editor: ToggleSetting,
      info: {
        label: "Show Total Number",
      },
      defaultValue: true,
    },
    showTarget: {
      editor: ToggleSetting,
      info: {
        label: "Show Target Number",
      },
      defaultValue: true,
    },
    rememberSettings: {
      editor: RememberSettings,
      info: {
        widgetName: WidgetNames.mab,
        widgetDisplayName: "MAB",
      },
    },
  },
  quickActions: {},
};
